import { type PropsWithChildren } from 'react';

import type { BehaviorTrackingProps } from '../../core/types/behavior-tracking-props.js';
import { DataTestId } from '../../core/types/data-props.js';
import { StylingProps } from '../../core/types/styling-props.js';

//#region Typings

/**
 * Accepted properties for the Select EmptyState
 * @public
 */
export type SelectEmptyStateProps = PropsWithChildren<unknown> &
  StylingProps &
  DataTestId &
  BehaviorTrackingProps;
//#endregion

/**
 * The `Select.EmptyState` component allows you to specify any content, that should
 * be shown when no select options are available. The `Select.EmptyState` component
 * is only valid within the `Select.Content` element.
 * @example
 * ```tsx
 * <Select.Content>
 *   <Select.EmptyState>
 *     No items found.
 *   </Select.EmptyState>
 * </Select.Content>
 * ```
 * @public
 */
export function SelectEmptyState(props: SelectEmptyStateProps): null {
  return null;
}
